import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTambah extends React.Component {
    render() {
        const { ShowModalDel2, CancelHandler, DeleteHandlerr, Model, ListDelete, DeleteHandlerr2 } = this.props
        return (

            <div>
                <Modal show={ShowModalDel2} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>HAPUS LIST ALAMAT</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Anda yakin ingin menghapus Alamat <br /> <br />

                            {
                                    ListDelete.map(data => {
                                        return (
                                            <p class="error">{data.label}, {data.address}</p>
                                        ) 
                                    })
                                }

                            <p>Anda tidak dapat mengembalikan alamat yang sudah dihapus</p>
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Tidak</button>
                        <button class="btn btn-danger" onClick={DeleteHandlerr2}>Yakin</button>


                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}